/* eslint-disable @next/next/no-img-element */
export function SocialButtons() {
	return (
		<div className="border-t-1 flex w-fit flex-wrap items-center justify-center gap-2 border-t border-black pt-2">
			<a
				className="block aspect-square h-6"
				href="https://twitter.com/gsma"
			>
				<img
					className="h-full w-full"
					src="/images/logos/x-logo-black.png"
					alt="Twitter X logo"
				/>
			</a>
			<a
				className="block aspect-square h-6"
				href="https://www.linkedin.com/company/gsma/"
			>
				<img
					className="h-full w-full"
					src="/images/logos/linkedin.png"
					alt="Linkedin logo"
				/>
			</a>
			<a
				className="block aspect-square h-6"
				href="https://www.youtube.com/gsma"
			>
				<img
					className="h-full w-full"
					src="/images/logos/logo-YouTube.avif"
					alt="YouTube logo"
				/>
			</a>
			<a
				className="block aspect-square h-6"
				href="https://www.instagram.com/gsmaglobal/"
			>
				<img
					className="h-full w-full"
					src="/images/logos/instagram.png"
					alt="Instagram logo"
				/>
			</a>
		</div>
	)
}
